/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _components = require('components');

var CategoryHero = (function (_Component) {
	_inherits(CategoryHero, _Component);

	function CategoryHero() {
		_classCallCheck(this, _CategoryHero);

		_Component.apply(this, arguments);
	}

	CategoryHero.prototype.render = function render() {
		var _classNames, _classNames2, _classNames3;

		var styles = require('./CategoryHero.css');

		var baseClasses = _classnames2['default']((_classNames = {}, _classNames[styles.Base] = true, _classNames[this.props.className] = this.props.className, _classNames[styles['Base--horizontal']] = this.props.horizontal, _classNames));

		var articleClasses = _classnames2['default']((_classNames2 = {}, _classNames2[styles.Article] = this.props.imageSrc, _classNames2[styles['Article--noImage']] = !this.props.imageSrc, _classNames2));

		var contentClasses = _classnames2['default']((_classNames3 = {}, _classNames3[styles.ContentArea] = this.props.imageSrc, _classNames3[styles['ContentArea--noImage']] = !this.props.imageSrc, _classNames3));

		return _react2['default'].createElement(
			'section',
			{ className: baseClasses },
			_react2['default'].createElement(
				'article',
				{ className: articleClasses },
				this.props.imageSrc && _react2['default'].createElement(
					'figure',
					{ className: styles.Figure },
					_react2['default'].createElement(
						_reactRouter.Link,
						{ className: styles.FigureLink, to: this.props.uri },
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + this.props.imageSrc })
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: contentClasses },
					_react2['default'].createElement(_components.MetaBar, {
						author: this.props.author,
						authorURI: this.props.authorURI,
						categories: this.props.postCategories,
						postDate: this.props.postDate,
						specialSeries: this.props.specialSeries }),
					_react2['default'].createElement(
						'header',
						{ className: styles.Header },
						_react2['default'].createElement(
							'h1',
							{ className: styles.Title },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles['Title--underlined'], to: this.props.uri },
								this.props.title
							)
						)
					),
					_react2['default'].createElement('div', { className: styles.Content, dangerouslySetInnerHTML: { __html: this.props.content } })
				)
			)
		);
	};

	_createClass(CategoryHero, null, [{
		key: 'propTypes',
		value: {
			author: _react.PropTypes.string.isRequired,
			authorURI: _react.PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool]),
			categories: _react.PropTypes.array,
			className: _react.PropTypes.string,
			content: _react.PropTypes.string.isRequired,
			horizontal: _react.PropTypes.bool,
			imageSrc: _react.PropTypes.string,
			postCategories: _react.PropTypes.oneOfType([_react2['default'].PropTypes.array, _react2['default'].PropTypes.object]),
			postDate: _react.PropTypes.string.isRequired,
			specialSeries: _react.PropTypes.object,
			title: _react.PropTypes.string.isRequired,
			uri: _react.PropTypes.string.isRequired
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			uri: '/',
			author: 'The Author',
			content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
			postDate: 'May 11, 1973',
			horizontal: true,
			title: 'The Title'
		},
		enumerable: true
	}]);

	var _CategoryHero = CategoryHero;
	CategoryHero = _reactRedux.connect(function (state) {
		return {
			categories: state.categories.data
		};
	})(CategoryHero) || CategoryHero;
	return CategoryHero;
})(_react.Component);

exports['default'] = CategoryHero;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CategoryHero/CategoryHero.js
 ** module id = 674
 ** module chunks = 0
 **/